export default class SieauParameterDto {
    constructor(obj) {
        this.parameter = obj.parameter
        this.value = obj.value
        this.module = 'SIEAU'
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin

        this.isChanged = obj.isChanged || false
    }
}